import axios from 'axios';

export const WA_NUMBER = '918383854950';
export const WA_NUMBER_DISPLAY = '+91 8383854950';
export const SUPPORT_EMAIL = 'support@settalkar.com';
const API_BASE = process.env.REACT_APP_BACKEND_URL;

export function waLink(text) {
  return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}

export const WA_DEFAULT_LINK = waLink('Hi Settalkar, I want to settle my traffic challan');

export function trackLead(source) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'generate_lead', lead_source: source });
  } catch (e) {}
  try {
    window.fbq && window.fbq('track', 'Lead', { content_name: source });
  } catch (e) {}
  try {
    window.gtag && window.gtag('event', 'conversion', { send_to: 'AW-XXXXXXXXX/CONVERSION_LABEL' });
  } catch (e) {}
}

export async function submitLead(payload) {
  const res = await axios.post(`${API_BASE}/api/leads`, payload, {
    headers: { 'Content-Type': 'application/json' },
    timeout: 8000,
  });
  return res.data;
}
